import { ContactShadows, Environment, Lightformer } from '@react-three/drei'
import { LIGHTFORMER_RIG } from './scene-contract'

export function NightEnvironment() {
  return (
    <>
      <color attach="background" args={['#03040a']} />
      <fog attach="fog" args={['#050711', 82, 270]} />
      <hemisphereLight args={['#5f8eff', '#020205', 0.75]} />
      <directionalLight color="#d8f8ff" intensity={2.2} position={[30, 55, -10]} castShadow />
      <Environment resolution={256} frames={1}>
        {LIGHTFORMER_RIG.map((light, index) => (
          <Lightformer
            // biome-ignore lint/suspicious/noArrayIndexKey: static immutable light rig
            key={index}
            form={light.kind === 'key' ? 'ring' : 'rect'}
            color={light.color}
            intensity={light.intensity}
            position={light.position}
            rotation={light.rotation}
            scale={light.scale}
          />
        ))}
      </Environment>
      <ContactShadows
        position={[0, 0.03, 0]}
        scale={220}
        resolution={512}
        frames={1}
        opacity={0.48}
        blur={2.4}
        far={18}
      />
    </>
  )
}
